/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_CleaningInputs */

const en_homepage_listen_in_cleaning = /** @type {(inputs: Homepage_Listen_In_CleaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cleaning`)
};

const es_homepage_listen_in_cleaning = /** @type {(inputs: Homepage_Listen_In_CleaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiando`)
};

/**
* | output |
* | --- |
* | "Cleaning" |
*
* @param {Homepage_Listen_In_CleaningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_cleaning = /** @type {((inputs?: Homepage_Listen_In_CleaningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_CleaningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_cleaning(inputs)
	return en_homepage_listen_in_cleaning(inputs)
});